import React, { useState, useEffect } from "react";

const ClubModal = ({ club, sports, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    sportId: "",
    location: "",
    foundedYear: "",
    description: "",
    logo: null,
  });

  useEffect(() => {
    if (club) {
      setFormData({
        name: club.name,
        sportId: club.sportId,
        location: club.location || "",
        foundedYear: club.foundedYear || "",
        description: club.description || "",
        logo: club.logo,
      });
    }
  }, [club]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(club ? { ...club, ...formData } : formData);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center">
      <div className="bg-surface-800 border border-line-strong rounded-xl w-full max-w-md">
        <h2 className="text-xl font-bold mb-4 text-white">
          {club ? "Edit Club" : "Add Club"}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-2 text-white">Name</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              className="w-full p-2 bg-surface-700 rounded text-white"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2 text-white">Sport</label>
            <select
              value={formData.sportId}
              onChange={(e) =>
                setFormData({ ...formData, sportId: e.target.value })
              }
              className="w-full p-2 bg-surface-700 rounded text-white"
              required
            >
              <option value="">Select a sport</option>
              {sports.map((sport) => (
                <option key={sport.sportId} value={sport.sportId}>
                  {sport.name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block mb-2 text-white">Location</label>
            <input
              type="text"
              value={formData.location}
              onChange={(e) =>
                setFormData({ ...formData, location: e.target.value })
              }
              className="w-full p-2 bg-surface-700 rounded text-white"
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2 text-white">Founded Year</label>
            <input
              type="number"
              value={formData.foundedYear}
              onChange={(e) =>
                setFormData({ ...formData, foundedYear: e.target.value })
              }
              className="w-full p-2 bg-surface-700 rounded text-white"
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2 text-white">Description</label>
            <textarea
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              className="w-full p-2 bg-surface-700 rounded text-white"
            />
          </div>
          <div className="mb-4">
            <label className="block text-white mb-2">Club Logo</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                setFormData((prev) => ({ ...prev, logo: file }));
              }}
              className="field"
            />
            {club?.logoUrl && (
              <img
                src={club.logoUrl}
                alt="Current logo"
                className="mt-2 w-20 h-20 object-cover rounded"
              />
            )}
          </div>
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-surface-600 rounded text-white"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-accent rounded text-white"
            >
              {club ? "Update" : "Add"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClubModal;
